
import SameShelfSettingsService from './SameShelfSettingsService';

export { default } from './SameShelfSettingsService';
export const sameShelfSettingsService = new SameShelfSettingsService();